import PropTypes from 'prop-types';
import React from 'react';
import { getInitials } from '../../../shared/util/transform';
import withToolTip from '../decorator/withToolTip';
import './Avatar.css';

const Avatar = React.memo(({ name, image }) => (
  <figure className="avatar" {...withToolTip(name)}>
    {image && (
      <img
        alt={name}
        style={{ backgroundImage: `url(${image})` }}
        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
      />
    )}
    <figcaption>{getInitials(name)}</figcaption>
  </figure>
));

Avatar.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string
};

Avatar.defaultProps = {
  image: ''
};

export default Avatar;
